import React, { useState, useEffect } from 'react';
import { submitFormData } from '../../../../pages/api';

const STR2 = ({ globalFields, formData, onFormDataChange }) => {
    const [localFormData, setLocalFormData] = useState({
        line: '',
        stringer: '',
        sectionA: {
            setTemperature: '',
            weldingTime: '',
            heatingPlate: {
                plate1: '',
                plate2: '',
                plate3: '',
                plate4: '',
                plate5: ''
            },
            remarks: ''
        },
        sectionB: {
            setTemperature: '',
            weldingTime: '',
            heatingPlate: {
                plate1: '',
                plate2: '',
                plate3: '',
                plate4: '',
                plate5: ''
            },
            remarks: ''
        }
    });

    const [metadata, setMetadata] = useState({ sectionA: {}, sectionB: {} });

    useEffect(() => {
        // Get metadata from sessionStorage
        const metadataString = sessionStorage.getItem('metadata');
        if (metadataString) {
            try {
                const parsedMetadata = JSON.parse(metadataString);
                // Check if stringerMachineParameterVerific exists and is an array
                const str2Data = Array.isArray(parsedMetadata?.stringerMachineParameterVerific)
                    ? parsedMetadata.stringerMachineParameterVerific.filter(
                          item => item.STR === 'STR2'
                      )
                    : [];

                const sectionAData = str2Data.find(item => item.Section === 'SectionA') || {};
                const sectionBData = str2Data.find(item => item.Section === 'SectionB') || {};

                setMetadata({
                    sectionA: sectionAData,
                    sectionB: sectionBData
                });

                // Pre-fill form data with metadata, excluding heating plates
                setLocalFormData(prev => ({
                    ...prev,
                    sectionA: {
                        ...prev.sectionA,
                        setTemperature: prev.sectionA.setTemperature || '',
                        weldingTime: prev.sectionA.weldingTime || ''
                    },
                    sectionB: {
                        ...prev.sectionB,
                        setTemperature: prev.sectionB.setTemperature || '',
                        weldingTime: prev.sectionB.weldingTime || ''
                    }
                }));
            } catch (error) {
                console.error('Error parsing metadata:', error);
                setMetadata({ sectionA: {}, sectionB: {} });
            }
        }

        // Handle pre-filled data or inspection data
        const prefilledData = sessionStorage.getItem('prefilledData');
        if (prefilledData) {
            try {
                const parsedData = JSON.parse(prefilledData);
                if (parsedData?.stringer?.STR2) {
                    setLocalFormData(prev => ({ ...prev, ...parsedData.stringer.STR2 }));
                }
            } catch (error) {
                console.error('Error parsing prefilledData:', error);
            }
        } else {
            const inspectionData = sessionStorage.getItem('inspectionData');
            if (inspectionData) {
                try {
                    const parsedInspectionData = JSON.parse(inspectionData);
                    if (parsedInspectionData?.stringer?.STR2) {
                        setLocalFormData(prev => ({ ...prev, ...parsedInspectionData.stringer.STR2 }));
                    }
                } catch (error) {
                    console.error('Error parsing inspectionData:', error);
                }
            }
        }
    }, []);

    useEffect(() => {
        setLocalFormData((prevData) => ({
            ...prevData,
            ...formData,
            sectionA: {
                ...prevData.sectionA,
                ...(formData?.sectionA || {})
            },
            sectionB: {
                ...prevData.sectionB,
                ...(formData?.sectionB || {})
            }
        }));
    }, [formData]);

    const handleChange = (e, section, field, subField) => {
        const { name, value } = e.target;

        let updatedData = { ...localFormData };

        if (section && field && subField) {
            updatedData[section][field][subField] = value;
        } else if (section && field) {
            updatedData[section][field] = value;
        } else {
            updatedData[name] = value;
        }

        setLocalFormData(updatedData);
        onFormDataChange(updatedData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const projectId = localStorage.getItem('selectedProject');
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        const inspectionShift = sessionStorage.getItem('inspectionShift');
        const inspectorName = sessionStorage.getItem('username');
        const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');

        const payload = {
            projectId,
            inspectionSupplier,
            inspectionDate,
            inspectionShift,
            inspectorName,
            status: 'completed',
            stringer: {
                STR2: { ...localFormData }
            }
        };

        try {
            const response = await submitFormData(payload);
            alert('Form submitted successfully!');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form!');
        }
    };

    return (
        <div className="p-6 max-w-3xl mx-auto bg-white rounded shadow-lg space-y-6">
            <h2 className="text-2xl font-semibold mb-4">STR2 Form</h2>
            <form onSubmit={handleSubmit}>
                {/* General fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block mb-1">Line</label>
                        <input
                            type="text"
                            name="line"
                            value={localFormData.line || ''}
                            onChange={(e) => handleChange(e)}
                            className="border p-2 rounded w-full"
                        />
                    </div>
                    <div>
                        <label className="block mb-1">Stringer</label>
                        <input
                            type="text"
                            name="stringer"
                            value={localFormData.stringer || ''}
                            onChange={(e) => handleChange(e)}
                            className="border p-2 rounded w-full"
                        />
                    </div>
                </div>

                {/* Section A */}
                <div className="border-t pt-4 mt-4">
                    <h3 className="text-lg font-semibold mb-2">Section A</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block mb-1">Set Temperature ({metadata.sectionA.setTemperature || 'N/A'})</label>
                            <input
                                type="number"
                                value={localFormData.sectionA?.setTemperature || ''}
                                onChange={(e) => handleChange(e, 'sectionA', 'setTemperature')}
                                className="border p-2 rounded w-full"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">Welding Time ({metadata.sectionA.weldingTime || 'N/A'})</label>
                            <input
                                type="number"
                                value={localFormData.sectionA?.weldingTime || ''}
                                onChange={(e) => handleChange(e, 'sectionA', 'weldingTime')}
                                className="border p-2 rounded w-full"
                            />
                        </div>
                    </div>
                    <h4 className="text-md font-semibold mt-2">Heating Plate (°C)</h4>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mt-2">
                        {[1, 2, 3, 4, 5].map((plate) => (
                            <div key={plate}>
                                <label className="block mb-1">
                                    Plate {plate} ({metadata.sectionA[`Plate${plate}`] || 'N/A'})
                                </label>
                                <input
                                    type="number"
                                    value={localFormData.sectionA?.heatingPlate[`plate${plate}`] || ''}
                                    onChange={(e) => handleChange(e, 'sectionA', 'heatingPlate', `plate${plate}`)}
                                    className="border p-2 rounded w-full"
                                />
                            </div>
                        ))}
                    </div>
                    <div className="mt-2">
                        <label className="block mb-1">Remarks for Section A</label>
                        <input
                            type="text"
                            value={localFormData.sectionA?.remarks || ''}
                            onChange={(e) => handleChange(e, 'sectionA', 'remarks')}
                            className="border p-2 rounded w-full"
                        />
                    </div>
                </div>

                {/* Section B */}
                <div className="border-t pt-4 mt-4">
                    <h3 className="text-lg font-semibold mb-2">Section B</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block mb-1">Set Temperature ({metadata.sectionB.setTemperature || 'N/A'})</label>
                            <input
                                type="number"
                                value={localFormData.sectionB?.setTemperature || ''}
                                onChange={(e) => handleChange(e, 'sectionB', 'setTemperature')}
                                className="border p-2 rounded w-full"
                            />
                        </div>
                        <div>
                            <label className="block mb-1">Welding Time ({metadata.sectionB.weldingTime || 'N/A'})</label>
                            <input
                                type="number"
                                value={localFormData.sectionB?.weldingTime || ''}
                                onChange={(e) => handleChange(e, 'sectionB', 'weldingTime')}
                                className="border p-2 rounded w-full"
                            />
                        </div>
                    </div>
                    <h4 className="text-md font-semibold mt-2">Heating Plate (°C)</h4>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mt-2">
                        {[1, 2, 3, 4, 5].map((plate) => (
                            <div key={plate}>
                                <label className="block mb-1">
                                    Plate {plate} ({metadata.sectionB[`Plate${plate}`] || 'N/A'})
                                </label>
                                <input
                                    type="number"
                                    value={localFormData.sectionB?.heatingPlate[`plate${plate}`] || ''}
                                    onChange={(e) => handleChange(e, 'sectionB', 'heatingPlate', `plate${plate}`)}
                                    className="border p-2 rounded w-full"
                                />
                            </div>
                        ))}
                    </div>
                    <div className="mt-2">
                        <label className="block mb-1">Remarks for Section B</label>
                        <input
                            type="text"
                            value={localFormData.sectionB?.remarks || ''}
                            onChange={(e) => handleChange(e, 'sectionB', 'remarks')}
                            className="border p-2 rounded w-full"
                        />
                    </div>
                </div>

                <button
                    type="submit"
                    className="bg-[#424752] text-white px-4 py-2 rounded mt-4 hover:bg-gray-500"
                >
                    Submit
                </button>
            </form>
        </div>
    );
};

export default STR2;